const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Image URL',
        dataIndex: 'image',
        render: defaultRender,
    },
    {
        title: 'Description',
        dataIndex: 'name',
        render: defaultRender,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        render: defaultRender,
    },
    {
        title: 'Action',
        dataIndex: 'action',
    },
];

export default columns;